import { CircularProgress } from '@mui/material'
import React from 'react'
import './overlay.scss'

interface OverlayProps {
  spinnerMessage?: string;
}

const Overlay: React.FC<OverlayProps> = ({ spinnerMessage }) => {
  return (
    <div className="overlay">
    <div className="spinner">
      <CircularProgress />
      {spinnerMessage && <p className="spinnerText">{spinnerMessage}</p>}
    </div>
  </div>
  )
}

export default Overlay